import { AlertTriangle } from 'lucide-react';

import { Button } from 'shadcn/components/ui/Button';
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from 'shadcn/components/ui/Dialog';

function HighVarianceDialog({ expected, onConfirm, onOpenChange, open, userDeclaredTotal, variance }) {
    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="sm:max-w-md">
                <DialogHeader>
                    <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-amber-100">
                        <AlertTriangle className="h-6 w-6 text-yellow-600" aria-hidden="true" />
                    </div>
                    <DialogTitle className="text-center mt-4 text-lg font-semibold">High Variance Detected</DialogTitle>
                </DialogHeader>
                <div className="text-sm text-center text-muted-foreground px-4">
                    <p>
                        There is a <span className="font-bold text-yellow-600">{variance}</span> variance between the
                        expected remaining units ({expected}) and what you've entered ({userDeclaredTotal}).
                    </p>
                    <p className="mt-2">Are you sure these counts are correct? Please verify before proceeding.</p>
                </div>
                <DialogFooter className="mt-6 sm:flex-row sm:justify-center sm:gap-3">
                    <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>
                        Go Back & Check
                    </Button>
                    <Button
                        type="button"
                        onClick={onConfirm}
                        className="bg-yellow-600 text-white shadow hover:bg-yellow-500/90"
                    >
                        Confirm & Continue
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}

export default HighVarianceDialog;
